import CustomLoader from "./CustomLoader";

export default CustomLoader